import { eventAddReducerTypes, eventShowReducerTypes, eventSingleShowReducerTypes } from 'types';

const eventAddState: eventAddReducerTypes.IEventAdd = {
    // Form
    id: null,
    title: '',
    short_description: '',
    description: '',
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    duration: '',
    fees: '',
    offer: '',
    who_can_attend: '',
    type: '',
    uploadFile: null,

    // Reducer
    isLoading: false,

    // Response
    message: '',
    status: false,
};

const eventShowState: eventShowReducerTypes.IEventShow = {
    last_page: 0,
    to: 0,
    total: 0,
    current_page: 0,
    data: [],
    isLoading: false,
    status: false,
    page: 1,
};

const eventSingleShowState: eventSingleShowReducerTypes.IEventSingleShow = {
    data: null,
    isLoading: false,
    status: false,
    eventId: null,
    type: '',
};

export { eventAddState, eventShowState, eventSingleShowState };
